var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetFiltersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.081 25.034L17.953 25.762C17.7056 25.9122 17.423 25.9945 17.1337 26.0007C16.8444 26.0068 16.5585 25.9366 16.305 25.7971C16.0515 25.6575 15.8392 25.4536 15.6896 25.2059C15.54 24.9581 15.4584 24.6753 15.453 24.386V20.108C15.4124 19.4883 15.1847 18.8955 14.8 18.408L11.728 15.177C11.3074 14.7372 11.0505 14.1664 11 13.56V11.708C10.9921 11.4897 11.0279 11.272 11.1053 11.0677C11.1826 10.8634 11.3 10.6766 11.4505 10.5182C11.601 10.3599 11.7817 10.2332 11.9818 10.1456C12.1819 10.058 12.3975 10.0112 12.616 10.008H23.289C23.7171 10.0096 24.1272 10.1803 24.4299 10.4831C24.7326 10.7858 24.9034 11.1959 24.905 11.624V13.4C24.8583 14.0932 24.574 14.7491 24.1 15.257",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.657 20.201C25.6574 20.8927 25.4663 21.5711 25.105 22.161C24.7689 22.723 24.2928 23.1882 23.7231 23.5112C23.1535 23.8343 22.5099 24.0041 21.855 24.0041C21.2002 24.0041 20.5565 23.8343 19.9869 23.5112C19.4173 23.1882 18.9412 22.723 18.605 22.161C18.2441 21.5711 18.0544 20.8925 18.057 20.201C18.057 19.702 18.1553 19.2078 18.3463 18.7468C18.5373 18.2858 18.8172 17.8669 19.17 17.514C19.5229 17.1611 19.9418 16.8812 20.4028 16.6903C20.8639 16.4993 21.358 16.401 21.857 16.401C22.3561 16.401 22.8502 16.4993 23.3112 16.6903C23.7723 16.8812 24.1912 17.1611 24.544 17.514C24.8969 17.8669 25.1768 18.2858 25.3678 18.7468C25.5587 19.2078 25.657 19.702 25.657 20.201Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.873 21.193L20.865 19.185",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.857 19.209L20.849 21.217",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.906 11.616V13.392C24.8575 14.0873 24.5731 14.7452 24.1 15.257L22.689 16.5C22.4166 16.4338 22.1373 16.4002 21.857 16.4C20.8491 16.4 19.8826 16.8004 19.17 17.513C18.4573 18.2256 18.057 19.1922 18.057 20.2C18.0566 20.8917 18.2477 21.5701 18.609 22.16C18.9041 22.659 19.3159 23.079 19.809 23.384V23.656C19.7995 23.9255 19.7291 24.1893 19.603 24.4276C19.4769 24.6659 19.2984 24.8726 19.081 25.032L17.953 25.76C17.7056 25.9102 17.423 25.9925 17.1337 25.9987C16.8444 26.0048 16.5585 25.9346 16.305 25.7951C16.0515 25.6555 15.8392 25.4516 15.6896 25.2039C15.54 24.9561 15.4584 24.6733 15.453 24.384V20.104C15.4102 19.4856 15.1846 18.8939 14.805 18.404L11.728 15.177C11.3119 14.7342 11.0556 14.1651 11 13.56V11.7C10.9921 11.4817 11.0279 11.264 11.1053 11.0597C11.1826 10.8554 11.3 10.6686 11.4505 10.5102C11.601 10.3519 11.7817 10.2252 11.9818 10.1376C12.1819 10.05 12.3975 10.0032 12.616 10H23.289C23.7172 10.0013 24.1276 10.172 24.4306 10.4747C24.7335 10.7775 24.9044 11.1877 24.906 11.616Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFiltersIcon);
export default __webpack_public_path__ + "static/media/ResetFiltersIcon.115c148dccf47d5d81ed55ddb436c7da.svg";
export { ForwardRef as ReactComponent };